import { Directive, ElementRef, HostListener, inject, output } from "@angular/core";

@Directive({
    selector: "[s25-ng-click-outside]",
    standalone: true,
})
export class S25ClickOutsideDirective {
    readonly clickOutside = output<void>();

    private readonly elementRef = inject(ElementRef);

    @HostListener("document:click", ["$event"])
    public onClick(event: Event) {
        // composedPath is captured when the event is dispatched, so a click on a node its own handler
        // removes (acknowledging an alert, closing a row) still reads as inside rather than outside.
        const inside = event.composedPath().includes(this.elementRef.nativeElement);
        if (!inside) this.clickOutside.emit();
    }
}
